import _ from 'lodash';
import { createSelector } from 'reselect';
import { NAME } from './constants';
import { selectors as coreSelectors } from '../core';
import * as types from './actionTypes';

export const getUserDetails = (state, id) => state[NAME].userDetails.items[id];
export const getUserFirstName = createSelector(getUserDetails, userData => _.get(userData, 'firstName'));
export const isLoadingUserProfile = state => coreSelectors.isLoading(state, types.GET_USER_DATA.NAME);